document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.querySelector('.searchform input[type="text"]');
    const searchIcon = document.querySelector('.searchwp-modal-form-trigger-el');

    if (searchIcon) {
        searchIcon.innerHTML = '<svg class="search-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M19 19L14.65 14.65M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z" stroke="#DF3011" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n</svg>';
    }

    if (searchInput && typeof SearchModalStrings !== 'undefined') {
        const searchTitle = document.createElement('div');
        searchTitle.textContent = SearchModalStrings.searchTitle;
        searchTitle.classList.add('search-title');
        searchInput.parentNode.insertBefore(searchTitle, searchInput);

        searchInput.setAttribute('placeholder', SearchModalStrings.searchPlaceholder);
    }
});
